module.exports = __webpack_public_path__ + "img/04.444f15be.svg";